
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import {throwError as observableThrowError,  Observable, of, Subject } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http/';
import 'rxjs/Rx';
import * as jwt_decode from 'jwt-decode';
import * as moment from 'moment';

import { environment } from "./../../../environments/environment";
export const TOKEN_NAME: string = 'access_token';

@Injectable({providedIn: 'root'})
export class LoginService {
    tokenSubject = new Subject<any>();
    redirectUrl: string;
    ssoServer = `${environment.AUTH_SERVER_URL}`;
    loginSystem = `${environment.AUTH_URL}/home?action=logout&app=attendance`;

    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) { }
    
    searchEmployee(str: string): Observable<any> {
      let params = new HttpParams();
      params = params.set('name', str);

      return this.http.get(environment.SERVER_URL +'/staff/search-by-name' + str, {params}).pipe(

          map(this.extractData),
          catchError(this.handleError),);
    }

    // old route: /individual_employment_setting/detail/' + id
    getAttendanceSetting(id:number) {
        const headers = new HttpHeaders({ 
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('access_token')
        });
        const options = { headers: headers };

        return this.httpClient.get(environment.SERVER_URL + '/individual_employment_setting/detail_by_date?staff_id='+ id + '&date=' + moment().format('YYYY-MM-DD'), options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getToken(): string {
        return localStorage.getItem(TOKEN_NAME);
    }

    setToken(token: string): void {
        localStorage.setItem(TOKEN_NAME, token);
    }

    getTokenExpirationDate(token: string): Date {
        const decoded = jwt_decode(token);
    
        if (decoded['exp'] === undefined) { return null; }
    
        const date = new Date(0);
        date.setUTCSeconds(decoded['exp']);
        return date;
    }

    isTokenExpired(token?: string): boolean {
        if (!token) { token = this.getToken(); }
        if (!token) { return true; }
    
        const date = this.getTokenExpirationDate(token);
        if (date === undefined) { return false; }
        return !(date.valueOf() > new Date().valueOf());
    }

    logout(): void {
        localStorage.removeItem('currentUser');
        localStorage.removeItem(TOKEN_NAME);
        localStorage.removeItem('setting');
        localStorage.removeItem('branch');
        localStorage.removeItem('worklistStaffs');
        localStorage.removeItem('attendanceStaffs');
        localStorage.removeItem('alertDetails');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('previousState');
        localStorage.removeItem('alertData');
        localStorage.removeItem('applicationDetails');
        localStorage.removeItem('access_token');
        localStorage.removeItem('alert_id');
        localStorage.removeItem('previousRoute');

        // redirect to login system
        console.log(this.loginSystem);
        window.location.href = this.loginSystem;
    }

    // to be fix
    recoverPassword(email: string): Observable<any>  {
        let body = JSON.stringify({email});
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let options = { headers: headers };
  
        // This function needs to be created in login system.
        return this.httpClient.post(environment.DB_API_URL + '/recoverPassword', body, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),)
  }


    private extractData(res: any) {
      let body = res;
      return body.data || {};
    }

    validateToken(): Observable<any> {
      const headers = new HttpHeaders({'content-type': 'application/json'});
      let token = this.getToken();
      let body = {
        token: token,
        app: 'ams'
      };

      return this.httpClient.post( environment.AUTH_SERVER_URL + '/appValidatetoken', body, {headers})
        .pipe(
          catchError(this.newErrorHandler)
        )
    }

    decodeToken(token: string): any {
      if(!token) {
        token = localStorage.getItem('access_token');
      }

      return jwt_decode(token);
    }

    // use to request token from the iframe login system
    requestToken() {
      let iframe = document.getElementById('login-system');
      // skip if no iframe is found
      if (iframe == null) return;

      let iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage('attendance', environment.AUTH_URL); 
      return;
    }

    private handleError (error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
        const body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }

        return observableThrowError(errMsg);
    }

    newErrorHandler(error: HttpErrorResponse) {
      let errorMessage = 'Unknown error!';

      if (error.error instanceof ErrorEvent) {
        // Client-side errors
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side errors
        if (error.status == 403) {
          return of({data: null, message: '403', success: false});
        } else {
          return of({data: null, message: '401', success: false});
        }
      }

      return of({data: null, message: errorMessage, success: false});
    }
}
